export const ADD_INTERVALS = 'ADD_INTERVALS'
export const ADD_INTERVAL = 'ADD_INTERVAL'
